import { Color } from '../../theme/Color/Color';
/**
 * WARN The HEX Colors below are not a part of the official color palette.
 *      Used within MessageBar component (to stand out from branding colors).
 *      Use at your own discretion.
 */
export var messageBarPalette = {
    alert: {
        color: '#c12d0f',
        backgroundColor: Color.error40,
        border: '#f5d1c9',
    },
    success: {
        color: '#007011',
        backgroundColor: Color.grassGreen20,
        border: Color.grassGreen40,
    },
    warning: {
        color: Color.thunder,
        backgroundColor: '#fefed0',
        border: '#baba00',
    },
    info: {
        color: Color.petrolBlue,
        backgroundColor: '#dbf0ff',
        border: '#87cdff',
    },
};
//# sourceMappingURL=palette.js.map